import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';
import { H4, Button, ProgressBar, FormGroup, InputGroup, NumericInput } from '@blueprintjs/core';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import { CsvBuilder } from "filefy";

import './VocByCorpus.css';
import MultivarStats from '../multivar/MultivarStats';
//import { min } from 'lodash';

class VocMultivar extends React.PureComponent {

  state = {
    dataType:'lemma',
    lemmaRegex:'.*',    
    maxLemmaNumber: 20,
    multivarData:[],
    waitingForMultivar:false, 
    multivarIsReady:false,
    calcRes:null,
  }

  componentDidMount() {
    this.fetchCalcRes(this.props.session_id);
    this.calcMultivarData({});
  }

  fetchCalcRes = (sessionId) => {
    const endpoint = process.env.REACT_APP_API_BASE +'/sessions/'+sessionId+'/calc_res-params.json';
    
    fetch(
        endpoint , {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        this.setState({ calcRes: data });
      });
    })
  }

  calcMultivarData = (args) => {
    const dataType=args.dataType ? args.dataType : this.state.dataType;
    const lemmaRegex=args.lemmaRegex ? args.lemmaRegex : this.state.lemmaRegex;
    const maxLemmaNumber=args.maxLemmaNumber ? args.maxLemmaNumber : this.state.maxLemmaNumber;

    const multivarData=[];
    for (const subCorpus of this.props.subCorpora) {
      const data=(dataType === "lemma")? 
        this.props.lemmaData[subCorpus].filter( line => line[0].match(RegExp(lemmaRegex))).sort( (a,b)=> b[1]-a[1] ).slice(0,maxLemmaNumber):
        this.props.catData[subCorpus];
      for (const line of data) {
        multivarData.push([
          line[0],
          subCorpus,
          line[1]
        ]);
      }  
    }
    this.setState({ multivarData });
  }

  computeMultivar = () => {

    const endpoint = '/compute_multivar.ajax.php';
    const data= {
      session_id:this.props.session_id,
      dataSetName:'freq_voc',
      multivarData:this.state.multivarData,
    };
    this.setState({ waitingForMultivar:true });
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        data:JSON.stringify(data)
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        this.fetchCalcRes(this.props.session_id);
        this.setState({ waitingForMultivar:false, multivarIsReady:true });
      });
    })
  };

  calcData = (sessionId,dataType)=> {
    var links={};
    if (! this.state.calcRes) {
      return {};
    }
    if (this.state.calcRes[dataType]) {
      if (this.state.calcRes[dataType].main && this.state.calcRes[dataType].main.MainTableWidget ) {
        links.main={};
        links.main.mainTable= process.env.REACT_APP_API_BASE+"/sessions/"+sessionId+"/"+dataType+"/main/"+this.state.calcRes[dataType].main.MainTableWidget;
      }

      if (this.state.calcRes[dataType].hclust && this.state.calcRes[dataType].hclust.success) {
        links.hclust={};
        links.hclust.plot=this.state.calcRes[dataType].hclust.plotWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
        links.hclust.distMat=this.state.calcRes[dataType].hclust.distMatWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].pca && this.state.calcRes[dataType].pca.success) {
        links.pca={};
        links.pca.varPlot=this.state.calcRes[dataType].pca.var.plotPanelFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].pca && this.state.calcRes[dataType].pca.success ) {
        links.pca.indPlot=this.state.calcRes[dataType].pca.ind.plotPanelFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].pamk_mds && this.state.calcRes[dataType].pamk_mds.success) {
        links.mds={};
        links.mds.plot=this.state.calcRes[dataType].pamk_mds.plotWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
        links.mds.distMat=this.state.calcRes[dataType].pamk_mds.distMatWidgetFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].ca && this.state.calcRes[dataType].ca.success) {
        links.ca={};
        links.ca.plot=this.state.calcRes[dataType].ca.caPlotPanelFile.fullpath.replace(/.var.www.html.lexicoscope_(2.0|beta)/,process.env.REACT_APP_API_BASE);
      }
      if (this.state.calcRes[dataType].xtab && this.state.calcRes[dataType].xtab.success) {
        links.xtab={};
        links.xtab.main=process.env.REACT_APP_API_BASE+"/sessions/"+sessionId+"/"+dataType+"/xtab/"+this.state.calcRes[dataType].xtab.main.MainTableWidget;
      }

    }
    return links;
  };

  render() {
    const { cats, session_id, t } = this.props;
    const { dataType, lemmaRegex, maxLemmaNumber, multivarData } = this.state;

    const tableRows=[];

    for (const line of multivarData) {
      tableRows.push({
        value:line[0],
        subCorpus:line[1],
        freq:line[2]
      });
    }

    const freqVocLinks=this.calcData(session_id,'freq_voc');
    const notEmpty=Object.keys(freqVocLinks).length>0;
    const freqVoc =<MultivarStats urls={freqVocLinks}  />;

    return(
      <>
        <Paper className="margin-bottom-1-rem padding-1-rem">
          
          <H4>{t('multivarStats')}</H4>
          
          <EnhancedSingleSelect
            label={t('chooseDataType')}
            options={[t('lemma'),t('posTags')]}
            value={this.state.dataType==='lemma'? t('lemma'): t('posTags')}
            name='chooseDataType'
            onChange={(e)=> {
              const newDataType = e.target.value.match(/lem/i)? 'lemma': 'cats';
              this.setState({ dataType: newDataType }); 
              this.calcMultivarData({ dataType: newDataType });
            }}
            popoverProps={{ minimal: true }}
          />

          { dataType==="lemma" &&
            <>
              <FormGroup label={t('maxNumberOfLemmasToConsider')} inline={true}>
                <NumericInput
                  min={20} 
                  buttonPosition={null}
                  value={maxLemmaNumber}
                  onValueChange={(e) => { 
                    this.setState({maxLemmaNumber:e.target.value});
                    this.calcMultivarData({maxLemmaNumber:e.target.value});
                  }}
                /> 
              </FormGroup>

              <FormGroup label={t('filteringRegex')}  inline={true}>
                <InputGroup 
                  id="lemmaRegex" 
                  type="text" 
                  value={lemmaRegex} 
                  onChange={(e) => {
                    this.setState({lemmaRegex:e.target.value});
                    this.calcMultivarData({lemmaRegex:e.target.value});
                  }}
                />
              </FormGroup>
            
              <EnhancedSingleSelect
                label={t('filterByCat')}
                options={cats}
                name='filterByCat'
                hasDefault={true}
                hasSelectableDefault={true}
                onChange={(e)=> {
                  this.setState({ lemmaRegex:"_"+e.target.value });
                  this.calcMultivarData({ lemmaRegex:"_"+e.target.value });
                }}
                popoverProps={{ minimal: true }}
              />
           </>
            
          }

          <MaterialTable
            title={dataType === 'lemma'? t('lemma'): t('posTags')}        
            columns={[
              { title: t('value'), field:'value' },
              { title: t('subCorpus'), field:'subCorpus' },
              { title: t('frequency'), field:'freq' },
            ]}
            data={tableRows}
            options={{
              sorting: true,
              filtering: true,
              exportButton: true,
              exportAllData: true,
              padding: 'dense',
              pageSize: 10,
              exportCsv: (columns, data) => {
                const fileName = 'multivar_'+dataType;
                const builder = new CsvBuilder(
                    fileName + ".csv"
                );
                builder
                    .setColumns(
                        ["val","subCorpus","freq"]
                    )
                    .addRows(
                      data.map((rowData) =>
                          [
                            rowData.val,
                            rowData.subCorpus,
                            rowData.freq,
                          ]
                        )
                    )
                    .exportFile();
              },
            }}
            components={{
                Pagination: paginationProps => (
                    <TablePagination
                      {...paginationProps}
                      rowsPerPageOptions={[10, 100, 1000, tableRows.length]}
                    />
              ),
              Container: props => (
                <Paper
                  {...props}
                  elevation={0}
                  className='straight'
                />
              ),
            }}
          />
          { this.state.waitingForMultivar &&
            <ProgressBar />
          }
          <p></p>
          <Button onClick={this.computeMultivar}>{t('computeMultivar')}</Button>
          
          { notEmpty && 
            <>
              {freqVoc}
            </>

          }
          
        </Paper>
            
      </>
    );
  }

}

VocMultivar.propTypes = {
  subCorpora: PropTypes.array,
  lemmaData:PropTypes.object,
  catData:PropTypes.object,
  cats: PropTypes.array,
  session_id: PropTypes.string,
};

export default withTranslation()(VocMultivar);
